import { useForm, useStore } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter/FilterWrapper'
import { TableFilterRow } from 'ui/temp/TableFilterRow'
import { BankUsersReportFilterParams } from '~bank-reports/types/BankUsersReport'

import { useUserReportContext } from '../../context/UserReportContext'

import { s } from './styles'

export const Filter = () => {
  const { data, state, navigate, clear } = useUserReportContext()
  const { activeOptions } = data

  const formApi = useForm({
    defaultValues: state as Pick<BankUsersReportFilterParams, 'active'>
  })

  const clearForm = () => {
    formApi.reset()
    clear()
  }

  return (
    <FilterPanel isDirty={useStore(formApi.store, (s) => s.isDirty) || false} onReset={clearForm}>
      <FilterWrapper>
        <TableFilterRow>
          <s.Col>
            <formApi.Field
              name="active"
              listeners={{
                onChange: ({ value, fieldApi }) => {
                  navigate({ [fieldApi.name]: value, page: 1 })
                  return undefined
                }
              }}
              children={(field) => (
                <FF
                  label="Status"
                  field={field}
                  input={(inputProps) => (
                    <Select {...inputProps} data-qa="Active" options-data-qa="Active options" data={activeOptions} />
                  )}
                />
              )}
            />
          </s.Col>
        </TableFilterRow>
      </FilterWrapper>
    </FilterPanel>
  )
}
